import { type HttpPostFormData, mapServerError } from '@/shared/infra/http'
import type { GalleryPhoto } from '@/shared/domain'
import type { UploadGalleryPhoto } from '@/modules/gallery/use-cases'

export class SupabaseUploadGalleryPhotoRepository {
  constructor(private readonly http: HttpPostFormData) {}

  execute: UploadGalleryPhoto = async (params) => {
    const form = new FormData()
    form.append('file', params.file)
    if (params.orgId) form.append('orgId', params.orgId)
    if (params.orgType) form.append('orgType', params.orgType)
    if (params.caption) form.append('caption', params.caption)
    if (params.takenAt) form.append('takenAt', params.takenAt)
    if (params.album) form.append('album', params.album)

    try {
      const response = await this.http.postFormData<{ photo: GalleryPhoto }>({
        url: '/club-gallery-photos/upload',
        body: form,
      })
      return response.photo
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
